/**
 * What the app shell does with the answer to GET /api/users/me. Only a refused session
 * (401, or 403: Spring Security answers an expired or unknown token with 403 on prod) signs
 * someone out; a rate limit, a restart during a deploy or a network blip keeps
 * the token, so nobody is sent back to the sign-in page for a hiccup.
 */
export type SessionAnswer =
  | { kind: 'user'; user: any }
  /** No session (401 or 403, the token is dropped): the routes send the person to sign in. */
  | { kind: 'signedOut' }
  /**
   * Grow did not answer properly (429, 5xx, a body that is not JSON). The token is kept and
   * the shell offers a retry: showing the sign-in page here sent people to sign in again for
   * nothing (QA sweep L-1, 2026-11-04).
   */
  | { kind: 'unavailable'; status: number };

export async function readSession(res: Response, dropToken: () => void): Promise<SessionAnswer> {
  if (res.status === 401 || res.status === 403) {
    dropToken();
    return { kind: 'signedOut' };
  }
  if (!res.ok) return { kind: 'unavailable', status: res.status };
  try {
    const data = await res.json();
    return data?.id ? { kind: 'user', user: data } : { kind: 'unavailable', status: res.status };
  } catch {
    return { kind: 'unavailable', status: res.status };
  }
}

/** A request that never got an answer (offline, the server restarting). */
export const NETWORK_FAILURE: SessionAnswer = { kind: 'unavailable', status: 0 };
